<ul class="list-group" *ngIf="menus?.length > 0">
     <li *ngFor="let menu of menus; trackBy: trackByMenuId" class="list-group-item p-0">
          <!-- Display the menu title and the + icon if there are submenus -->
          <div class="d-flex justify-content-between align-items-center">
               <span class="ps-{{level+1}} py-2">
                    {{ menu.index }} . <input type="checkbox" [(ngModel)]="menu.enable" class="form-check-input"
                         (change)="editor.callReportParentMethod(menu, 'enable')"> {{ menu.reporttitle }}
                    {{menu.url && menu.url ? ('- ' + menu.url) : '' }}
               </span>

               <!-- Add checkboxes and buttons -->
               <span class="d-flex align-items-center" *ngIf="edit">
                    <!-- Checkboxes for Enable and New Tab -->
                    <div class="form-check form-check-inline" *ngIf="menu.url && menu.url !=''">
                         <input type="checkbox" [(ngModel)]="menu.new_tab" class="form-check-input" id="inlineCheckbox1"
                              (change)="editor.callReportParentMethod(menu, 'newTab')">
                         <label class="form-check-label me-2" for="inlineCheckbox1">
                              <i class="bi bi-box-arrow-up-right" data-bs-toggle="tooltip"
                                   title="menu open in new tab"></i>
                         </label>
                    </div>

                    <!-- Buttons for moving and managing the menu -->
                    <span class="btn-group btn-group-sm">
                         <button (click)="editor.callReportParentMethod(menu, 'moveUp')" type="button"
                              class="btn  btn-small btn-light text-primary btn-outline-secondary "
                              [disabled]="menu.index == 1" data-bs-toggle="tooltip" title="Move Up"><i
                                   class="fa fa-arrow-up"></i>
                         </button>
                         <button (click)="editor.callReportParentMethod(menu, 'moveDown')" type="button"
                              class="btn btn-light btn-small btn-outline-secondary">
                              <i class="fa fa-arrow-down" data-bs-toggle="tooltip" title="Move Down"></i></button>
                         <button (click)="editor.callReportParentMethod(menu, 'moveBack')" type="button"
                              class="btn  btn-small btn-light text-primary btn-outline-secondary"
                              [disabled]="menu.index == 1 || menu.parent == null">
                              <i class="fa fa-arrow-left" data-bs-toggle="tooltip" title="Move Back"></i></button>
                         <button (click)="editor.callReportParentMethod(menu, 'moveNext')" type="button"
                              class="btn btn-light btn-small btn-outline-secondary" [disabled]="menu.index == 1">
                              <i class="fa fa-arrow-right" data-bs-toggle="tooltip"
                                   title="Make Child of Previous"></i></button>
                         <button (click)="editor.callReportParentMethod(menu, 'remove')" type="button"
                              class="btn  text-danger btn-light btn-small btn-outline-secondary"
                              data-bs-toggle="tooltip" title="Remove this menu">
                              <i class="fa fa-times" data-bs-toggle="tooltip" title="Remove"></i></button>
                    </span>
               </span>
          </div>

          <!-- Recursively render submenus -->
          <app-recursive-report [menus]="getNestedMenus(menu.index)" [menusArray]="menusArray" [editor]="editor"
               [level]="level+1" [edit]="edit"></app-recursive-report>
     </li>
</ul>